var SDK_VERSION = '7.15.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
